export const QuoteDetailsConstants = {
    UTLIZATION_NUMBER_REQUIRED: "This field is required.",
    UTLIZATION_NUMBER_VALID: "Please Enter a valid number",
    UTLIZATION_NUMBER_GREATER: "This field cannot be negative or zero.",
}